import React, { useState } from "react";

const PostAdmitUpdate = ({ data, updateData }) => {
  const [formState, setFormState] = useState(data || {});

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedForm = { ...formState, [name]: value };
    setFormState(updatedForm);
    updateData(updatedForm);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Post-Admit Information Data", formState);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label
            htmlFor="patientID"
            className="block text-gray-700 font-medium"
          >
            Patient ID
          </label>
          <input
            type="text"
            id="patientID"
            name="patientID"
            value={formState.patientID || ""}
            onChange={handleChange}
            placeholder="Enter patient ID"
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label htmlFor="fullName" className="block text-gray-700 font-medium">
            Full Name
          </label>
          <input
            type="text"
            id="fullName"
            name="fullName"
            value={formState.fullName || ""}
            onChange={handleChange}
            placeholder="Enter full name"
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label htmlFor="address" className="block text-gray-700 font-medium">
            Address
          </label>
          <input
            type="text"
            id="address"
            name="address"
            value={formState.address || ""}
            onChange={handleChange}
            placeholder="Enter address"
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label
            htmlFor="guardianName"
            className="block text-gray-700 font-medium"
          >
            Guardian Name
          </label>
          <input
            type="text"
            id="guardianName"
            name="guardianName"
            value={formState.guardianName || ""}
            onChange={handleChange}
            placeholder="Enter guardian name"
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label
            htmlFor="guardianContact"
            className="block text-gray-700 font-medium"
          >
            Guardian Contact Number
          </label>
          <input
            type="text"
            id="guardianContact"
            name="guardianContact"
            value={formState.guardianContact || ""}
            onChange={handleChange}
            placeholder="Enter guardian contact number"
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label
            htmlFor="insuranceDetails"
            className="block text-gray-700 font-medium"
          >
            Insurance Details
          </label>
          <select
            id="insuranceDetails"
            name="insuranceDetails"
            value={formState.insuranceDetails || ""}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">Select Insurance Type</option>
            <option value="Cashless">Cashless</option>
            <option value="Reimbursement">Reimbursement</option>
            <option value="None">None</option>
          </select>
        </div>
      </div>
      <button
        type="submit"
        className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
      >
        Save & Next
      </button>
    </form>
  );
};

export default PostAdmitUpdate;
